<template>
    <transition name="modal-fade">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop >
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>
                <form class="row">

                    <div class="col-12 title">{{title}}</div>
                    <div class="box col-12 row">
                        <div class="col-12">
                            <span class="mandatory bold">* Mandatory</span>
                        </div>
                        <div class="col-12">
                            <label class="form-label">Sub-Contractor/Business Name</label>

                            <div class="autocomplete-container">
                                <input type="text"
                                       v-model="PersonalInfo.Business.Name"
                                       @focus="focusDropdown('Name')"
                                       placeholder="Business Name"
                                       @blur="dismissDropdown"
                                       class="form-input" />
                                <ul v-if="showDropdown === 'Name'" class="dropdown-list">
                                    <li v-for="(option, index) in filteredOptions"
                                        :key="index"
                                        @mousedown.prevent="selectOption(option, 'Name')"
                                        class="dropdown-item">
                                        {{ option.Name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-6">
                            <label class="form-label">First Name<span class="mandatory">*</span></label>
                            <div class="autocomplete-container">
                                <input type="text"
                                       v-model="PersonalInfo.Business.ContactFirstName"
                                       @focus="focusDropdown('ContactFirstName')"
                                       @blur="dismissDropdown"
                                       placeholder="First Name"
                                       class="form-input" />
                                <ul v-if="showDropdown === 'ContactFirstName'" class="dropdown-list">
                                    <li v-for="(option, index) in filteredOptions"
                                        :key="index"
                                        @mousedown.prevent="selectOption(option, 'ContactFirstName')"
                                        class="dropdown-item">
                                        {{ option.ContactFirstName }} {{ option.ContactLastName }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-6">
                            <label class="form-label">Last Name<span class="mandatory">*</span></label>
                            <div class="autocomplete-container">
                                <input type="text"
                                       v-model="PersonalInfo.Business.ContactLastName"
                                       @focus="focusDropdown('ContactLastName')"
                                       @blur="dismissDropdown"
                                       placeholder="First Name"
                                       class="form-input" />
                                <ul v-if="showDropdown === 'ContactLastName'" class="dropdown-list">
                                    <li v-for="(option, index) in filteredOptions"
                                        :key="index"
                                        @mousedown.prevent="selectOption(option, 'ContactLastName')"
                                        class="dropdown-item">
                                        {{ option.ContactFirstName }} {{ option.ContactLastName }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-8">
                            <label class="form-label">Address<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Address" placeholder="Address">
                        </div>
                        <div class="col-4">
                            <label class="form-label">Unit</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Unit" placeholder="Unit">
                        </div>

                        <div class="col-6 col-sm-6">
                            <label class="form-label">City<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.City" placeholder="City">
                        </div>
                        <div class="col-6 col-sm-6">
                            <label class="form-label">Province<span class="mandatory">*</span></label>
                            <select class="form-select" v-model="PersonalInfo.Business.Province">
                                <option value="">Please Select</option>
                                <option v-for="obj in $core.data.Provinces" :key="obj" :val="obj">{{obj}}</option>
                            </select>
                        </div>

                        <div class="col-6 col-sm-5">
                            <label class="form-label">Postal Code<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.PostalCode" placeholder="Postal Code">
                        </div>
                        <div class="col-6 col-sm-5">
                            <label class="form-label">Fax</label>
                            <input type="number" class="form-control" v-model="PersonalInfo.Business.Fax" placeholder="Fax">
                        </div>

                        <div class="col-6 col-sm-5">
                            <label class="form-label">Business Phone No.<span class="mandatory">*</span></label>
                            <input type="text" @input="filterNumbers" class="form-control" v-model="PersonalInfo.Business.Phone" placeholder="Business Phone No." maxlength="10">
                        </div>
                        <div class="col-3">
                            <label class="form-label">Ext</label>
                            <input type="number" class="form-control" v-model="PersonalInfo.Business.PhoneExtension" placeholder="Ext">
                        </div>

                        <div class="col-12 col-sm-9">
                            <label class="form-label">Business Email<span class="mandatory">*</span></label>
                            <input type="email" class="form-control" v-model="PersonalInfo.Business.Email" placeholder="Business Email">
                        </div>

                        
                        <div class="col-12">
                            <p class="form-label sub-title">Alternate Contact Info</p>
                        </div>

                        <div class="col-12">
                            <div>
                                <label class="form-label col-3">Phone# </label>
                                <div class="form-check form-check-inline" style="display: none;">
                                    <input  @change="samePhoneChange" type="checkbox" v-model="PersonalInfo.SamePhone"  id="samePhone" class="form-check-input" />
                                    <label for="samePhone" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as business phone no above</label>
                                </div>
                            </div>
                            <div class="col-6 col-sm-5">
                                <input type="text"  class="form-control col-6" v-model="PersonalInfo.Business.ContactPhone" placeholder="Phone Number" maxlength="10">
                            </div>

                        </div>
                        <div class="col-12">
                            <div>
                                <label class="form-label col-3">Email </label>
                                <div class="form-check form-check-inline" style="display: none;">
                                    <input @change="sameEmailChange" type="checkbox" v-model="PersonalInfo.SameEmail" id="sameEmail" class="form-check-input" />
                                    <label for="sameEmail" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as business email above</label>
                                </div>
                            </div>
                            <div class="col-12 col-sm-9">
                                <input type="text" class="form-control" v-model="PersonalInfo.Business.ContactEmail" placeholder="Email">
                            </div>

                        </div>

                    </div>


                    <div v-if="isEditMode" class="col-12" style="text-align:right;">
                        <div class="btn btn-positive" @click="save">Save</div>
                    </div>
                    <div v-else class="col-12" style="text-align:right;">
                        <div class="btn btn-positive" @click="addToProject">Save</div>
                    </div>

                </form>
                 
            </div>
            
        </div>
    </transition>

</template>

<script>
    export default {
        data() {
            return {
                PersonalInfo: {
                    SameEmail: false,
                    SamePhone: false,
                    Business: { Name: '', ContactFirstName: '', ContactLastName: '', ContactEmail: '', ContactPhone: '', Address: '', Unit: '', City: '', Province: '', PostalCode: '', Fax: '', Phone: '', PhoneExtension: '' },
                },
                title: "Business information",
                showDropdown: null, // Tracks the active dropdown field ('Name', 'FirstName', 'LastName')
                SubContractorList: [{ Name: 'Business A', ContactFirstName: 'John', ContactLastName: 'Doe' },
                    { Name: 'Business B', ContactFirstName: 'Jane', ContactLastName: 'Smith' },],
                isEditMode: false,

            }
        },
        mounted() {
            this.getSubContractorList();

        },

        watch: {
            'PersonalInfo.Business.Name'(newVal) {
                const value = newVal || ''; // Ensure `newVal` is a string
                this.showDropdown = value.trim() === '' ? null : 'Name';
            },
            'PersonalInfo.Business.ContactFirstName'(newVal) {
                const value = newVal || ''; // Ensure `newVal` is a string
                this.showDropdown = value.trim() === '' ? null : 'ContactFirstName';
            },
            'PersonalInfo.Business.ContactLastName'(newVal) {
                const value = newVal || ''; // Ensure `newVal` is a string
                this.showDropdown = value.trim() === '' ? null : 'ContactLastName';
            },
        },

        computed: {
            // Dynamically filter options based on the active input field
            filteredOptions() {
                if (!this.showDropdown) return [];
                const field = this.showDropdown; // 'Name', 'ContactFirstName', or 'LastName'
                const searchValue = this.PersonalInfo.Business[field]?.toLowerCase() || '';
                return this.SubContractorList.filter((obj) =>
                    obj[field]?.toLowerCase().includes(searchValue)
                );
            },
        },
        methods: {

            filterNumbers(event) {
                var phoneNumber = event.target.value.replace(/\D/g, "");     
                console.log("phoneNumber", phoneNumber);         
                event.target.value = phoneNumber;
            },

            // Handle dropdown visibility on input focus
            focusDropdown(field) {
                setTimeout(() => {
                    this.showDropdown = field;
                }, 200); // Add a slight delay to allow option selection
                //this.showDropdown = field;
            },

            dismissDropdown() {
                setTimeout(() => {
                    this.showDropdown = null;
                }, 200); // Add a slight delay to allow option selection
            },
            // Updates filtered options based on the field being typed in
            updateFilteredOptions(field) {
                const searchValue = this.PersonalInfo.Business[field]?.toLowerCase() || '';
                this.filteredOptions = this.SubContractorList.filter((obj) =>
                    obj[field]?.toLowerCase().includes(searchValue)
                );
            },

            // Handles selection of an option
            selectOption(option, field) {
                this.PersonalInfo.Business[field] = option[field];

                this.dismissDropdown();

                //console.log("options", option);

                this.syncOtherFields(option); // Sync other fields if needed
            },

            // Sync related fields (optional)
            syncOtherFields(selectedItem) {
                this.PersonalInfo.Business.Name = selectedItem.Name || '';
                this.PersonalInfo.Business.ContactFirstName = selectedItem.ContactFirstName || '';
                this.PersonalInfo.Business.ContactLastName = selectedItem.ContactLastName || '';

                this.PersonalInfo.Business.Address = selectedItem.Address || '';
                this.PersonalInfo.Business.Unit = selectedItem.Unit || '';
                this.PersonalInfo.Business.City = selectedItem.City || '';
                this.PersonalInfo.Business.Province = selectedItem.Province || '';
                this.PersonalInfo.Business.PostalCode = selectedItem.PostalCode || '';
                this.PersonalInfo.Business.Email = selectedItem.Email || '';
                this.PersonalInfo.Business.Phone = selectedItem.Phone || '';
                this.PersonalInfo.Business.Fax = selectedItem.Fax || '';
                this.PersonalInfo.Business.PhoneExtension = selectedItem.PhoneExtension || '';

                this.PersonalInfo.Business.ContactEmail = selectedItem.ContactEmail || '';
                this.PersonalInfo.Business.ContactPhone = selectedItem.ContactPhone || '';

                if (!this.isEditMode) {
                    this.PersonalInfo.Business.Id = selectedItem.Id || '';
                }
                
            },

            getSubContractorList() {

                this.$http.request("get", `/api/app/subcontractor/readlist`).then((res) => {

                    if (res?.Type == 200) {
                        this.SubContractorList = res.Data;

                        //console.log("this.SubContractorList", this.SubContractorList);
                    }
                });

            },

            dataUpdate(obj, isEdit) {

                //console.log(JSON.stringify(obj));
                this.PersonalInfo = obj;
                this.isEditMode = isEdit;
                this.dismissDropdown();
            },

            sameEmailChange() {
                if (this.PersonalInfo.SameEmail) {
                    this.PersonalInfo.Business.ContactEmail = this.PersonalInfo.Business.Email;
                }
            },
            samePhoneChange() {
                console.log("samePhoneChange", this.PersonalInfo.SamePhone);
                if (this.PersonalInfo.SamePhone) {
                    this.PersonalInfo.Business.ContactPhone = this.PersonalInfo.Business.Phone;
                }
            },
            addToProject() {
                /*
                if (!this.PersonalInfo.Business.Name) {
                    
                    this.$emit('alertMessage', 'Business Name Field is mandatory');
                   // window.$message.error('Please enter the business');
                    return;
                }
                */
                if (!this.PersonalInfo.Business.ContactFirstName) {
                    this.$emit('alertMessage', 'First Name Field is mandatory');
                    //window.$message.error('Please enter the first name');
                    return;
                }
                if (!this.PersonalInfo.Business.ContactLastName) {
                    this.$emit('alertMessage', 'Last Name Field is mandatory');
                    //window.$message.error('Please enter the last name');
                    return;
                }
                if (!this.PersonalInfo.Business.Address) {
                    this.$emit('alertMessage', 'Address Field is mandatory');
                    //window.$message.error('Please enter the address');
                    return;
                }
                if (!this.PersonalInfo.Business.City) {
                    this.$emit('alertMessage', 'City Field is mandatory');
                    //window.$message.error('Please enter the city');
                    return;
                }
                if (!this.PersonalInfo.Business.Province) {
                    this.$emit('alertMessage', 'Province Field is mandatory');
                    //window.$message.error('Please choose the province');
                    return;
                }
                
                if (!this.PersonalInfo.Business.PostalCode) {
                    this.$emit('alertMessage', 'Postal Code Field is mandatory');
                    //window.$message.error('Please enter the postal code');
                    return;
                }

                if (!this.PersonalInfo.Business.Email) {
                    this.$emit('alertMessage', 'Business Email Field is mandatory');
                    //window.$message.error('Please enter the postal code');
                    return;
                }
                if (!this.PersonalInfo.Business.Phone) {
                    this.$emit('alertMessage', 'Business Phone Number Field is mandatory');
                    //window.$message.error('Please enter the postal code');
                    return;
                }
                this.$emit('addToProject', this.PersonalInfo);
            },
            save() {

                /*
                if (!this.PersonalInfo.Business.Name) {
                    
                    this.$emit('alertMessage', 'Business Name Field is mandatory');
                   // window.$message.error('Please enter the business');
                    return;
                }
                */
                if (!this.PersonalInfo.Business.ContactFirstName) {
                    this.$emit('alertMessage', 'First Name Field is mandatory');
                    //window.$message.error('Please enter the first name');
                    return;
                }
                if (!this.PersonalInfo.Business.ContactLastName) {
                    this.$emit('alertMessage', 'Last Name Field is mandatory');
                    //window.$message.error('Please enter the last name');
                    return;
                }
                if (!this.PersonalInfo.Business.Address) {
                    this.$emit('alertMessage', 'Address Field is mandatory');
                    //window.$message.error('Please enter the address');
                    return;
                }
                if (!this.PersonalInfo.Business.City) {
                    this.$emit('alertMessage', 'City Field is mandatory');
                    //window.$message.error('Please enter the city');
                    return;
                }
                if (!this.PersonalInfo.Business.Province) {
                    this.$emit('alertMessage', 'Province Field is mandatory');
                    //window.$message.error('Please choose the province');
                    return;
                }
                
                if (!this.PersonalInfo.Business.PostalCode) {
                    this.$emit('alertMessage', 'Postal Code Field is mandatory');
                    //window.$message.error('Please enter the postal code');
                    return;
                }

                if (!this.PersonalInfo.Business.Email) {
                    this.$emit('alertMessage', 'Business Email Field is mandatory');
                    //window.$message.error('Please enter the postal code');
                    return;
                }
                if (!this.PersonalInfo.Business.Phone) {
                    this.$emit('alertMessage', 'Business Phone Number Field is mandatory');
                    //window.$message.error('Please enter the postal code');
                    return;
                }

                this.$emit('saveProfile', this.PersonalInfo);
            }

        }
    }
</script>

<style scoped>
     
    .autocomplete-container {
        position: relative;
        margin-bottom: 16px;
    }

    .form-input {
        width: 100%;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    .dropdown-list {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        max-height: 150px;
        overflow-y: auto;
        z-index: 10;
        padding:0px;
    }

    .dropdown-item {
        padding: 8px;
        cursor: pointer;
    }

        .dropdown-item:hover {
            background: #f0f0f0;
        }


    .modal-overlay {
        z-index:999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
        max-width:100%;
    }

    .modal-content {
        background-color: white;
        height: auto;
        width: 500px;
        max-width: 90vh;
        max-height: 90vh;
        margin-top: 5%;
        padding: 0px 24px;
        border-radius: 20px;
       
    }
     
    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .form-check-inline {
        margin: 4px 0px;
    }

    .form-check-label {
        vertical-align: middle;
    }

    .form-check-input {
        vertical-align: middle;
    }
</style>